module.exports = __webpack_public_path__ + "static/media/04.f5009c93.jpg";